/**
 * Product Video Autoplay for Grid Layouts
 * Automatically plays videos when grid-2-cols or grid-mix layout is selected
 */

class ProductVideoAutoplay {
  constructor() {
    console.log('[Video Autoplay] Initializing...');
    this.productInfo = document.querySelector('product-info');
    
    if (!this.productInfo) {
      console.log('[Video Autoplay] ERROR: product-info element not found');
      return;
    }
    
    console.log('[Video Autoplay] Found product-info element');
    this.init();
  }

  init() {
    // Check if we should autoplay based on layout
    const mediaLayout = this.productInfo.dataset.mediaLayout;
    console.log('[Video Autoplay] Media layout:', mediaLayout);
    
    const shouldAutoplay = mediaLayout === 'grid-2-cols' || mediaLayout === 'grid-mix';
    console.log('[Video Autoplay] Should autoplay?', shouldAutoplay);
    
    if (shouldAutoplay) {
      // Save the current scroll position
      const scrollPosition = window.scrollY;
      
      // Wait a moment for the page to fully load
      setTimeout(() => {
        this.enableVideoAutoplay();
        
        // Restore scroll position after a brief moment
        setTimeout(() => {
          window.scrollTo(0, scrollPosition);
        }, 100);
      }, 500);
      
      // Also watch for dynamically loaded videos
      this.observeVideos();
    } else {
      console.log('[Video Autoplay] Autoplay not enabled for this layout');
    }
  }

  enableVideoAutoplay() {
    console.log('[Video Autoplay] Looking for videos...');
    
    // Find all video elements in the product media
    const videos = this.productInfo.querySelectorAll('video');
    console.log('[Video Autoplay] Found videos:', videos.length);
    
    videos.forEach((video, index) => {
      console.log(`[Video Autoplay] Processing video ${index + 1}`);
      this.makeVideoAutoplay(video);
    });

    // Handle deferred media (videos that need to be loaded)
    const deferredMedias = this.productInfo.querySelectorAll('deferred-media');
    console.log('[Video Autoplay] Found deferred media elements:', deferredMedias.length);
    
    deferredMedias.forEach((deferredMedia, index) => {
      console.log(`[Video Autoplay] Processing deferred media ${index + 1}`);
      
      // Check if it contains a video template
      const template = deferredMedia.querySelector('template');
      if (template) {
        const templateContent = template.innerHTML;
        console.log('[Video Autoplay] Template found, checking content...');
        
        // Check if template contains video or iframe (for external videos)
        if (templateContent.includes('<video') || templateContent.includes('<iframe')) {
          console.log('[Video Autoplay] Video content detected in template, loading...');
          
          // Save scroll position before loading
          const scrollY = window.scrollY;
          
          // Trigger the deferred media to load
          const loadButton = deferredMedia.querySelector('button');
          if (loadButton) {
            console.log('[Video Autoplay] Clicking load button');
            loadButton.click();
          } else if (typeof deferredMedia.loadContent === 'function') {
            console.log('[Video Autoplay] Calling loadContent method');
            deferredMedia.loadContent();
          } else {
            // Manually load the content
            console.log('[Video Autoplay] Manually loading template content');
            const content = template.content.cloneNode(true);
            deferredMedia.appendChild(content);
          }
          
          // Restore scroll position immediately
          window.scrollTo(0, scrollY);
          
          // Wait for content to load, then autoplay
          setTimeout(() => {
            const video = deferredMedia.querySelector('video');
            const iframe = deferredMedia.querySelector('iframe');
            
            console.log('[Video Autoplay] After loading - video:', !!video, 'iframe:', !!iframe);
            
            // Save scroll again before playing
            const currentScrollY = window.scrollY;
            
            if (video) {
              this.makeVideoAutoplay(video);
            } else if (iframe) {
              console.log('[Video Autoplay] Found iframe (external video)');
              this.handleExternalVideo(iframe);
            }
            
            // Restore scroll position after autoplay
            setTimeout(() => {
              window.scrollTo(0, currentScrollY);
            }, 50);
          }, 1000);
        }
      } else {
        console.log('[Video Autoplay] No template found in deferred media');
        
        // Maybe the video is already loaded, check for it
        const video = deferredMedia.querySelector('video');
        const iframe = deferredMedia.querySelector('iframe');
        
        if (video) {
          console.log('[Video Autoplay] Found existing video in deferred media');
          this.makeVideoAutoplay(video);
        } else if (iframe) {
          console.log('[Video Autoplay] Found existing iframe in deferred media');
          this.handleExternalVideo(iframe);
        }
      }
    });
  }

makeVideoAutoplay(video) {
  console.log('[Video Autoplay] Making video autoplay');

  // 🔒 HARD disable controls (prevents hover UI)
  video.removeAttribute('controls');
  video.controls = false;

  // Prevent hover/focus UI
  video.setAttribute('tabindex', '-1');

  // Set required attributes for autoplay
  video.setAttribute('autoplay', '');
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('loop', '');
  video.muted = true;
  video.autoplay = true;

    
    console.log('[Video Autoplay] Attempting to play...');
    
    // Save current scroll position
    const scrollY = window.scrollY;
    
    // Try to play the video
    const playPromise = video.play();
    
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.log('[Video Autoplay] ✓ Video playing successfully!');
          // Restore scroll position after play starts
          window.scrollTo(0, scrollY);
        })
        .catch(error => {
          console.log('[Video Autoplay] ✗ Video autoplay failed:', error);
          // Try again after a short delay
          setTimeout(() => {
            video.play()
              .then(() => window.scrollTo(0, scrollY))
              .catch(e => console.log('[Video Autoplay] Retry failed:', e));
          }, 500);
        });
    }
  }

  handleExternalVideo(iframe) {
    // For YouTube/Vimeo iframes, add autoplay parameter to URL
    let src = iframe.src;
    console.log('[Video Autoplay] Processing external video iframe');
    
    if (src.includes('youtube.com') || src.includes('youtu.be')) {
      if (!src.includes('autoplay=1')) {
        src += (src.includes('?') ? '&' : '?') + 'autoplay=1&mute=1';
        iframe.src = src;
        console.log('[Video Autoplay] Updated YouTube URL for autoplay');
      }
    } else if (src.includes('vimeo.com')) {
      if (!src.includes('autoplay=1')) {
        src += (src.includes('?') ? '&' : '?') + 'autoplay=1&muted=1';
        iframe.src = src;
        console.log('[Video Autoplay] Updated Vimeo URL for autoplay');
      }
    }
  }

  observeVideos() {
    console.log('[Video Autoplay] Starting video observer...');
    
    // Watch for new videos being added to the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'VIDEO') {
              console.log('[Video Autoplay] New video detected via observer');
              // Save scroll position before autoplay
              const scrollY = window.scrollY;
              this.makeVideoAutoplay(node);
              // Restore scroll
              setTimeout(() => window.scrollTo(0, scrollY), 50);
            } else if (node.querySelector) {
              const videos = node.querySelectorAll('video');
              if (videos.length > 0) {
                console.log('[Video Autoplay] New videos detected via observer:', videos.length);
                const scrollY = window.scrollY;
                videos.forEach(video => this.makeVideoAutoplay(video));
                setTimeout(() => window.scrollTo(0, scrollY), 50);
              }
            }
          }
        });
      });
    });

    observer.observe(this.productInfo, {
      childList: true,
      subtree: true
    });
  }
}

// Initialize when DOM is ready
console.log('[Video Autoplay] Script loaded');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[Video Autoplay] DOM loaded, initializing...');
    new ProductVideoAutoplay();
  });
} else {
  console.log('[Video Autoplay] DOM already loaded, initializing...');
  new ProductVideoAutoplay();
}